export default {
  check_drawings_Legend: "意见图例",
  check_drawings_list: "审图列表",
  detail: "查看",
  return_to_check_list: "返回审图列表",
  check_drawings_suggestions: "审核意见",
  booth_report_info: "展位报图资料详情",
  modify: "修改",
  cancel: "撤销报图申请",
  booth_info: "展位信息",
  status: "状态",
  expo_name: "展会名称",
  exhibitor: "参展单位",
  boothNo: "展位号",
  "保险验证码": "保险验证码",
  booth_area: "展位面积",
  top_structure_coverage_area: "顶部结构覆盖面积",
  booth_size: "展台尺寸(长×宽)",
  largest_size_across_the_structure: "横跨结构最大尺寸",
  total_power_consumption_of_the_booth: "展位总用电功率",
  power_line_specifications: "用电线路规格",
  minimum_thickness_of_loadBearing_wall: "承重墙体最小厚度",
  highest_point_to_the_ground_vertical_height: "最高点至地面垂直高度",
  producer_info: "承建商信息",
  taxCode: "社会统一信用代码",
  construction_unit: "承建商单位",
  builder_manager: "承建商负责人",
  construction_manager: "施工负责人",
  contact_way: "联系方式",
  email: "邮箱",
  fax: "传真",
  check_imgs: "审核图片",
  click_for_larger_image: "点击查看大图",
  construction_personnel_registration_info: "施工人员登记表",
  name: "姓名",
  sex: "性别",
  idcard: "身份证",
  phone: "电话",
  remark: "备注",
  car_info: "布撤展承建商货车通行证申请登记",
  number: "数量",
  car_type: "车辆类型",
  number_plate: "车牌号",
  car_license_mailing_payment_info: "车证邮寄到付信息",
  recipient: "收件人",
  postal_number: "邮编",
  address: "地址",
  female: "女",
  male: "男",
  external_vehicle: "外埠车辆",
  local_vehicle: "本地车辆",
  值守电工姓名: "值守电工姓名",
  值守电工联系电话: "值守电工联系电话",
  序号: "序号",
  报图类别: "报图类别",
  报图资料: "报图资料",
  审核状态: "审核状态",
  审核时间: "审核时间",
  展开查看审图详情: "展开查看审图详情",
  实际施工单位: "实际施工单位"
};



// WEBPACK FOOTER //
// ./src/i18n/zh-cn/drawings/drawingsDetail.js